'use strict';
import $ from 'jquery';

export default class M167 {
  static init() {
    $('.module-m167').each((index, el) => {
      new M167($(el));
    });
  }

  constructor($el) {
    this.el = $el;
    const self = this;
    this.el.find('.tabs-nav').each(function () {
      $(this).find('a:first-child').addClass('active');
    });

    // $('.tabs-nav a:first-child').addClass('active');
    this.el.find('.tab-content').each(function () {
      $(this).find('.tabContent').hide()
      $(this).find('.tabContent:first-child').show()
    });

    this.el.find('.tabs-nav a').on('click', function () {
      self.el.find('.tabs-nav a').removeClass('active');
      $(this).addClass('active');
      self.el.find('.tabContent').hide();
      const activeTab = $(this).attr('href');
      $(activeTab).fadeIn();
      return false;
    });
  }
}
